<template>
	<div id='warp_div'>
		<a-popover :visible="visible" placement="leftTop" trigger="click" :destroyTooltipOnHide="true"
			:overlayStyle="{width:'calc(8rem)'}" @visibleChange="moreEvent()"
			:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
			<template slot="content">
				<div class="warp_title">
					<div
						v-if='(record.schedule == 1 && record.handle == 1)||(record.schedule == 2 && record.handle == 0)'>
						<a-row>
							<a-col :span="8">
								推送
							</a-col>
							<a-col :span="7">
							</a-col>
							<a-col :span="9">
								<a-switch v-model='tswitch' @change="onChanget" />
							</a-col>
						</a-row>
					</div>
					<div v-if='record.schedule == 3 && record.handle == 1'>
						<a-row>
							<a-col :span="8">
								热门
							</a-col>
							<a-col :span="7">
							</a-col>
							<a-col :span="9">
								<a-switch v-model='hotswitch' @change="onChangehot" />
							</a-col>
						</a-row>
					</div>
					<div>
						<a-row>
							<a-col :span="8">
								排序
							</a-col>
							<a-col :span="6">
							</a-col>
							<a-col :span="10" class='warp_uimg'>
								<img title='上' :src="IconShang" alt="" @click='handz("goup")' style="margin-right: 5px;">
								<img title='下' :src="IconXia" alt="" @click='handz("godown")'>
							</a-col>
						</a-row>
					</div>
				</div>
			</template>
			<img :src="record.moreShowBol ? icon_gengduo1 : icon_gengduo" class="imageC">
		</a-popover>
		<handItem v-if='ishand' @child='handfn' :record='record'></handItem>
	</div>
</template>

<script>
	import icon_gengduo from '@/image/look_img.png';
	import icon_gengduo1 from '@/image/look_img1.png';
	import App from '@/assets/app.js';
	import handItem from './handItem'
	export default {
		props: ['record', 'params'],
		components:{
			handItem
		},
		data() {
			return {
				icon_gengduo,
				icon_gengduo1,
				ishand:false,
				visible: false,
				IconShang: require('@/image/icon_shang.png'),
				IconXia: require('@/image/icon_xia.png'),
				tswitch: true,
				hotswitch: true,
			}
		},
		created() {
			// if (this.record.hot_status == 1) {
			// 	this.hotswitch = false
			// } else if (this.record.hot_status == 2) {
			// 	this.tswitch = false
			// } else {
			// 	this.hotswitch = false
			// 	this.tswitch = false
			// }

		},
		methods: {
			handfn(){
				this.ishand = false
				this.$emit('child', true)
			},
			handz(val) {
				this.$ajax({
					method: "post",
					url: this.$api.sortHandle,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"iposelling_id": this.record.iposelling_id,
						"flag": val, //  goup 上移一位  godown 下移一位
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', true)
						this.visible = false
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			onChangehot(checked) {
				let str = ''
				if (checked) {
					str = 2
				} else {
					str = 0
				}
				this.onChange(str)
			},
			onChanget(checked) {
				let str = ''
				if (checked) {
					str = 1
				} else {
					str = 0
				}
				this.onChange(str)
			},
			onChange(checked) {
				this.$ajax({
					method: 'post',
					url: this.$api.HotStatus,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"iposelling_id": this.record.iposelling_id,
						"hot_status": checked //0 正常 1 推送 2 熱門
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', true)
						this.visible = false
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			//彈出前操作
			moreEvent() {
				if(!this.record.createtime){
					App.oTool.warningT('未收到莊張數據');
					return
				}
				this.ishand = true
				// if (this.visible) {
				// 	this.visible = false
				// } else {
				// 	if (this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0) {
				// 		App.oTool.warningT('無更多操作權限');
				// 	} else if (this.params.missionflag) {
				// 		App.oTool.warningT('審核狀態無法進行更多操作');
				// 	} else {
						// this.visible = true
				// 	}
				// }
			},
		}
	}
</script>

<style lang="scss" scoped>
	#warp_div {
		.ant-switch-checked {
			background-color: #1890ff;
		}

		.warp_uimg {
			text-align: right;

			img {
				cursor: pointer;
			}
		}
	}

	.warp_title>div {
		margin: 0 auto;
		width: 80%;
		padding: 7px 0;
	}

	.warp_title {
		paddding: 8px;
	}
</style>
